export default __webpack_public_path__ + "static/5-attend-46989d0179714fda92f6bf6f52a3a476.jpg";